import React, { useEffect, useRef } from "react";
import { CardLabel, SelectedCard } from "./styled";

import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { isDefined } from "Utils/functions";
import { Result } from "../interfaces";

interface Props {
  id?: string;
  value: string;
  options: Result[];
  isLoading?: boolean;
  onReset?: () => void;
  resetButtonContent?: React.ReactNode;
  toggleShouldFocusSearchField: (value: boolean) => void;
}

export const SelectedResult = ({
  id,
  value,
  options,
  isLoading,
  onReset,
  resetButtonContent,
  toggleShouldFocusSearchField,
}: Props): React.ReactElement => {
  const selected = options.find(
    ({ value: resultValue }) => resultValue === value,
  );

  const selectedRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedRef.current) {
      selectedRef.current.focus();
    }
  }, []);

  return (
    <>
      <SelectedCard
        tabIndex={-1}
        id={`${id}-selected`}
        ref={selectedRef}
        variant="border"
      >
        <CardLabel>{selected?.label}</CardLabel>
        {isLoading && <ThemedSpinner style={{ alignSelf: "center" }} />}
      </SelectedCard>
      {isDefined(resetButtonContent) && (
        <ThemedButton
          type="button"
          variant="text"
          id={`button-${id}-reset`}
          trackId={`${id}-reset`}
          onClick={() => {
            onReset && onReset();
            toggleShouldFocusSearchField(true);
          }}
          marginTop="16px"
        >
          {resetButtonContent}
        </ThemedButton>
      )}
    </>
  );
};
